import { type DrawAdditionalPlayerInformation } from 'components/dialogs/draw/publicDrawDisplaySettings/types';
import { type MatchParticipantStatusCategory } from 'components/dialogs/scoringDialog/typedefs/scoringTypes';
import { type Category } from 'typedefs/event';
import { type Format } from 'utils/dateTimeUtils';
import { type ScalingType, type ScalingTypeOptions } from 'utils/scalings';
import { type WtnScalingOptions } from 'utils/scalings/wtn';

export enum AppClient {
  USTA = 'USTA',
  ITA = 'ITA',
  TSI = 'TSI',
  DMOR = 'DMOR',
  TEST = 'TEST',
  SOLO = 'SOLO',
}

export enum Feature {
  SUSPENSIONS = 'SUSPENSIONS',
  SAFE_PLAY = 'SAFE_PLAY',
  RANKINGS_AND_RATINGS = 'RANKINGS_AND_RATINGS',
  PLAYER_PROFILES = 'PLAYER_PROFILES',
  MULTI_PAIRED_PARTICIPANTS = 'MULTI_PAIRED_PARTICIPANTS',
  SYNC_ROSTERS = 'SYNC_ROSTERS',
  PLAYTRACKER = 'PLAYTRACKER',
  VIRTUAL_CHECK_IN = 'VIRTUAL_CHECK_IN',
  OPEN_TEAM_MANUAL_SCORING = 'OPEN_TEAM_MANUAL_SCORING',
}

export interface ClientConfig {
  defaultTheme?: string;
  clientName: string;
  publicAssetsRoute: string;
  clientLogo?: string;
  disableFeatures?: Feature[];
  publicSiteDisplayName: string;
  showOrganisationId: boolean;
  scorecardHomeDisplaySide?: number;
  organisationId?: string;
  defaultLocale?: string;
  formats?: {
    pickerDateFormat?: string;
    pickerTimeFormat?: string;
    pickerDateTimeFormat?: string;
    dateFormat?: Format;
    timeFormat?: Format;
    dateTimeFormat?: Format;
  };
  additionalPlayerInfoOptions: Array<DrawAdditionalPlayerInformation>;
  copyrightName?: string;
  scalingTypes: (['WTN', WtnScalingOptions?] | [Exclude<ScalingType, 'WTN'>, ScalingTypeOptions?])[];
  mockPersonExtensions?: Record<string, any>;
  mockParticipants?: Record<string, any>[];
  legacyAssistantSearch?: boolean;
  courtsAvailableHours?: number;
  courtsDefaultMaxStartTime?: string;
  ageDivisions: Record<Partial<Category>, Array<string>>;
  statusCategories?: Array<MatchParticipantStatusCategory>;
}
